import store from '../store/store'
import {api} from "./api";

// Synchronize data with backend
export const synchronizer = {

    /**
     * Lazy data loader
     */
    lazyLoader() {
        for(const key of Object.keys(this.loadList)) {

            switch(key) {
                case "tree-task":
                    window.app.$dispatch("tree/loadTasksList", Object.values(this.loadList[key]));
                    break;
            }

            // Delete item
            delete this.loadList[key];
        }
    },

    /**
     * Load resource
     * @param type
     * @param id
     */
    addToLoader(type, id) {

        // Init list
        if(!this.loadList[type]) this.loadList[type] = [];

        // Key name
        const key = type+"-"+id;

        // Add item to load
        if(!this.loadedItems[key]) this.loadList[type].push(id); else this.loadedItems[key] = 1;
    },

    /**
     * Subscription updater
     */
    subscriptionUpdater() {

        // Update subscriptions
        if(this.subscriptions) for(let channel of Object.keys(this.subscriptions)) {
            api.call(false, "get", `/api/subscribe/${channel}`);
        }
    },

    /**
     * Subscribe on channel
     * @param channel
     * @param callback
     */
    subscribe(channel, callback) {
        // Init list
        if(!this.subscriptions) this.subscriptions = {};

        // Check for channel and callback
        if(!this.subscriptions[channel]) this.subscriptions[channel] = {};

        // Set subscription
        this.subscriptions[channel][callback] = callback;

        // Subscribe on the server
        api.call(false, "get", `/api/subscribe/${channel}`);
    },

    /**
     * Unsubscribe
     * @param channel
     * @param callback
     */

    unsubscribe(channel, callback) {
        // Init list
        if(this.subscriptions[channel][callback]) this.subscriptions = {};

        // Check for channel and callback
        if(!this.subscriptions[channel]) this.subscriptions[channel] = {};

        // Set subscription
        this.subscriptions[channel][callback] = callback;

        // Subscribe on the server
        api.call(false, "get", `/api/unsubscribe/${channel}`);
    },

    /**
     * Process starter
     */
    init(user) {

        if(this.loadedItems !== undefined) return;

        // Already loaded items
        this.loadedItems = {};

        // Lazy load list
        this.loadList = {};

        // Init loader
        setInterval(() => {this.lazyLoader()}, 500);

        // Subscription checker
        setInterval(() => {this.subscriptionUpdater()}, 10*1000);

        // Setup socket listener
        window.Echo.private('user-' + user.id).listen("UserNotificationEvent", (data) => {

            // Attribute changes update
            if (data['channel']) {

                // Process each message
                for(let chData of data['channel']) {
                    // Check for channel
                    if(this.subscriptions && this.subscriptions[chData['channel']]) {
                        for(let callback of Object.values(this.subscriptions[chData['channel']])) {
                            callback(chData);
                        }
                     }
                }

                // Set messages
                //store.commit("messenger/SET_MESSAGES", data['MessengerMessage']);
            }

            // Check for tasks to be updated
            if (data['tasks']) {
                window.app.$dispatch('tree/loadNodeStructure', data['tasks'].map(el => el.id)).catch(() => {});
                store.commit("tree/SET_TASKS", data['tasks']);
            }

            if (data['taskusers']) {
                // Load tasks structure
                window.app.$dispatch('tree/loadNodeStructure', data['taskusers'].map(el => el.task_id)).catch(() => {});
                store.commit("taskuser/SET_TASKUSERS", data['taskusers']);
            }
            if (data['positions']) {
                // Load tasks structure
                window.app.$dispatch('tree/loadNodeStructure', data['positions'].map(el => el.task_id)).catch(() => {});
                store.commit("positions/SET_POSITIONS", data['positions']);
            }
            if (data['notifications']) {

                // Load tasks structure
                window.app.$dispatch('tree/loadNodeStructure', data['notifications'].map(el => el.source_id)).catch(() => {});

                // Apply notifications
                store.commit("notifications/SET_NOTIFICATIONS", data['notifications']);

                // Show notification
                data['notifications'].forEach(t => {

                    // Check for details
                    if (!t.deleted_at && (
                        t.action_type === 'comment' ||
                        t.action_type === 'mention-comment'
                    )) {
                        // Play sound
                        api.play(require(t.action_type === 'comment' ? "../assets/sounds/message.mp3" : "../assets/sounds/mention.mp3"));
                    }
                });

            }

            if (data['comments']) store.commit("chat/SET_MESSAGES", data['comments']);

            // Messenger messages
            if (data['MessengerMessage']) {
                // Set messages
                store.commit("messenger/SET_MESSAGES", data['MessengerMessage']);
            }

            // Messenger content
            if (data['MessengerMessageContent']) {
                //console.log("content=", data['MessengerMessageContent']);
                // Set messages
                store.commit("messenger/SET_ATTACHMENTS", data['MessengerMessageContent']);
            }

            // Messenger discussions
            if (data['MessengerDiscussion']) {
                //console.log(data['MessengerDiscussion']);
                store.commit("messenger/SET_DISCUSSIONS", data['MessengerDiscussion']);
            }
        });
    }

};
